import {ExpandMoreProps} from "./types";
import {IconButton} from "@mui/material";
import {styled} from "@mui/material/styles";

// Стилированная кнопка со стрелкой, которая поворачивается
export const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
        duration: theme.transitions.duration.shortest,
    }),
}));